
export function findKeyByValue (obj, value) {
  return findKeyByValuePredicate(obj, v => v === value)
}
export function findKeyByValuePredicate (obj: any, predicate) {
  const i = Object.values(obj).findIndex(predicate)
  return Object.keys(obj)[i]
}

export function removeInArray (arr: any[], predicate) {
  const i = arr.findIndex(predicate)
  if (i > -1) arr.splice(i, 1)
}
